import navbarSearchAndPinList from 'config/navbarSearch'
import theme from 'config/theme'

const state = {
    isSidebarActive: true,
    breakpoint: null,
    sidebarWidth: "default",
    reduceButton: theme.sidebarCollapsed,
    bodyOverlay: false,
    sidebarItemsMin: false,
    theme: theme.theme || 'light',
    navbarSearchAndPinList: navbarSearchAndPinList,
    AppActiveUser: {
        id: 0,
        name: 'John Doe',
        about: 'Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.',
        img: 'avatar-default.png',
        status: 'online',
    },

    themePrimaryColor: theme.primary,

    starredPages: navbarSearchAndPinList.data.filter((page) => page.highlightAction),

    campaignListState: null,

    abTestForNewAd: false, 

    testIdForReloadForm: 0,
    
    whImage: {},


};

export default state
